import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth-routes/admin/uptakes')({
  beforeLoad: () => {
    throw redirect({ to: '/admin/uptake' })
  },
})
